const adminUsers = [
  "F0CKbEkyojefvmgJUWTgMtDFdKM2", // samholdenuk@gmail.com       (Sam)
  "xAA3SnmUUEcjZX0L4sT7VrFWtYZ2", // mindstackapp@gmail.com      (Mindstack account)
  "I19mPURJfEQ6oIsfWij6LwK37aw2", // gobbojohnson@gmail.com      (Gobbo Johnson)
  "T1q9pmgIjPgxV2PxQ5bKUqUoUc22", // starlineuser@gmail.com      (Starline test user)
];

export default adminUsers;
